"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function EducationalDisclaimer() {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  // wait for page to load before querying target element
  useEffect(() => {
    let $target: HTMLElement | null = null;

    if (
      ($target = document.querySelector("#site-footer .site-footer__container"))
    ) {
      setTarget($target);
    }
  }, []);

  return (
    target &&
    createPortal(
      <div className="site-footer__disclaimer">
        <p>
          The information shared here is designed to educate and empower
          veterans, but it is not a substitute for personalized financial,
          accounting, tax, or legal advice. Every situation is different. Please
          consult a licensed professional to discuss your specific
          circumstances.
        </p>
      </div>,
      target as HTMLElement,
    )
  );
}
